// extracted by mini-css-extract-plugin
export var scrollArea = "_pz-0";